// Source: https://www.melia.com/zh/meliarewards/terms-conditions
// Section 11, captured 2026-09-21. Preserve wording, punctuation and tier values.
export const PAGE_TITLE = 'Meliá Rewards 会员计划';
export const tiers = ['White', 'Silver', 'Gold', 'Platinum'];
export const sectionTitles = {
  benefits: '11.1 根据会员等级，计划权益如下：',
  conditions: '11.2 部分计划权益的获取与享受条件',
  changes: '11.3.福利获取条件的变更'
};
export const conditionsIntroduction = '部分上述计划权益的获取与享受条件如下：';
export const changes = '本计划福利及获取该等福利的条件可能发生变更。所有者或管理者可在 https://www.melia.com/meliarewards的登录区域内，为获取上述计划福利设定附加条件或补充要求。';

export const conditions = [
  { id: 'a', paragraphs: ['除另有明文规定外，计划权益仅适用于会员本人。'] },
  { id: 'b', paragraphs: ['欲享受与住宿相关的权益，账户会员必须实际入住该酒店。'] },
  {
    id: 'c',
    paragraphs: ['“延迟退房”权益是指，在附件二（城市酒店与度假酒店）所定义的度假酒店可于下午 2 点退房，在城市酒店可于下午 4 点退房。此权益始终取决于酒店房态，且须有与所预订房型同级的客房可供使用。此权益亦适用于由会员的未成年子女或受扶养人入住的第二间客房。']
  },
  {
    id: 'd',
    paragraphs: [
      '“同行宾客免费早餐”权益仅适用于按“仅房费”价格进行的预订，且适用于整个或部分住宿期间，前提是标准早餐费作为抵店后的额外服务支付。此权益可由不必然入住酒店的同行宾客享受。',
      '“同行宾客免费早餐”权益不适用于提供全包价的酒店，亦不适用于餐厅非由 Meliá 直接管理的酒店。'
    ]
  },
  {
    id: 'e',
    paragraphs: [
      '“升级至高级客房”权益是指升级至所预订客房类型的上一级房型，始终以酒店客房供应情况为准，且仅适用于符合资格的会员本人所预订的客房。此权益须于办理入住时提出申请。',
      '“升级至高级客房”权益一经授予，宾客有权在整个住宿期间保持该升级后的房型。酒店可将特定房型（例如总统套房）排除在“升级至高级客房”权益之外。'
    ]
  },
  {
    id: 'f',
    paragraphs: ['住宿八折优惠券。仅适用于同一预订编号内、住宿日期相同的房间。若为不同预订编号的单独预订，则每个预订编号需使用一张优惠券。已全部或部分使用积分支付的预订，不可使用住宿八折优惠券。折扣优惠券在会员保持 Gold 或 Platinum 等级期间持续有效。']
  },
  {
    id: 'g',
    paragraphs: ['机场贵宾休息室使用权。此使用权为 MeliáRewards Platinum 会员专属权益，凭此可进入机场贵宾休息室。此权益仅限会员持有 MeliáRewards Platinum 等级期间方可兑换，任何未享用或未使用的权益将被取消。本条款未明确规定的任何事项，应以 https://www.melia.com/meliarewards登录区域内所示的具体条款与条件为准。']
  },
  {
    id: 'h',
    paragraphs: ['仅限入住会员本人客房的人员，方可进入我们旗下 Meliá、Gran Meliá 及 Paradisus by Meliá 酒店的贵宾区域。若会员预订中包含的第二间客房由其未成年子女或受扶养人入住，则该第二间客房的住客亦有权享用此权益。进入上述贵宾区域不包含酒店早餐服务（除非会员预订中已包含早餐），且该使用权受贵宾区域容量限制，已为此服务付费的宾客享有优先权。']
  },
  {
    id: 'i',
    paragraphs: ['“生日惊喜”权益可能包含授予计划项下的某项权益。在此情况下，适用本计划规定的一般条款与条件，除非该“生日惊喜”活动本身另有特定的条款与条件规定。']
  }
];

export const benefitGroups = [
  {
    id: 'points', title: '', rows: [
      {
        id: 'points', title: '积分累积', label: '积分累积。',
        values: [
          '每消费 1 欧元/美元（税前）可获 10 积分',
          '每消费 1 欧元/美元（税前）可获 11 积分',
          '每消费 1 欧元/美元（税前）可获 13 积分',
          '每消费 1 欧元/美元（税前）可获 14 积分'
        ]
      }
    ]
  },
  {
    id: 'value', title: '更多尊享价值', rows: [
      { id: 'room-discount', title: '住宿预订专属折扣', label: '住宿预订专属折扣。', values: [true, true, true, true] },
      {
        id: 'breakfast', title: '同行宾客免费早餐',
        label: '同行宾客免费早餐（仅适用于“仅房费”价格预订）。',
        values: [false, true, true, true], conditionIds: ['d']
      },
      { id: 'wifi', title: '免费无线网络', label: '免费无线网络。', values: [true, true, true, true] },
      { id: 'birthday', title: '生日惊喜礼遇', label: '生日惊喜礼遇。', values: [true, true, true, true], conditionIds: ['i'] },
      {
        id: 'upgrade', title: '升级至高级客房',
        label: '升级至高级客房。\n（适用于办理入住时，并须视客房供应情况而定）。',
        values: [false, false, false, true], conditionIds: ['e']
      },
      {
        id: 'coupons', title: '住宿八折优惠券',
        label: '3 张住宿八折优惠券。 折扣不可相互叠加，亦不得与其他现行促销同时使用。',
        values: [false, false, true, true], conditionIds: ['f']
      }
    ]
  },
  {
    id: 'earn-and-use', title: '更多获取与使用可能（积分赚取与使用）', rows: [
      {
        id: 'dining-spa', title: '餐厅及水疗中心消费',
        label: '在本集团旗下品牌餐厅及水疗中心消费（积分将根据酒店促销活动累积）。',
        values: [true, true, true, true]
      },
      { id: 'hotel-stays', title: '酒店住宿消费', label: '在本集团旗下酒店住宿消费。', values: [true, true, true, true] },
      {
        id: 'hotel-services', title: '酒店自有服务',
        label: '使用本集团旗下酒店自有服务（积分将根据酒店促销活动累积）。',
        values: [true, true, true, true]
      },
      { id: 'partners', title: '合作公司消费', label: '通过本计划合作公司消费。', values: [true, true, true, true] }
    ]
  },
  {
    id: 'time', title: '更多时间便利', rows: [
      {
        id: 'late-checkout', title: '延迟退房',
        label: '度假酒店延迟退房至下午 2 点，城市酒店延迟退房至下午 4 点（需视酒店实际房态而定）。',
        values: [false, false, true, true], conditionIds: ['c']
      },
      { id: 'priority-checkin', title: '优先办理入住', label: '抵达酒店时优先办理入住。', values: [false, false, true, true] },
      {
        id: 'hotel-lounge', title: '酒店贵宾区域',
        label: '可进入本集团旗下 Meliá Hotels & Resorts、Gran Meliá 及 Paradisus by Meliá 品牌的贵宾区域\n（进入该区域不包含早餐服务，除非预订中已包含此项）。',
        values: [false, false, false, true], conditionIds: ['h']
      },
      {
        id: 'airport-lounge', title: '机场贵宾休息室',
        label: '全球超过 1,200 个机场贵宾休息室的2次使用权。',
        values: [false, false, false, true], conditionIds: ['g']
      }
    ]
  }
];

export const generalConditionIds = ['a', 'b'];
export const appendixReference = '附件二（城市酒店与度假酒店）';
